import React, { Component } from "react"

import Title from "../../../components/global/Title/Title"
import Content from "../../../components/global/Content/Content"

export default class Services extends Component {
  render() {
    const { acf } = this.props.data;

    return(
      <section className="">
        <div className="max-w-screen-xl mx-auto md:px-6 md:flex md:flex-wrap lg:px-8">
          <div className="w-full text-center mb-12">
            <Title level="2">{acf && acf.title_services}</Title>
          </div>
          <div className="w-full">
            <div className="flex overflow-x-scroll lg:overflow-x-visible lg:flex-no-wrap lg:-mx-4">
              {acf && acf.services && acf.services.map(item => (
                <div key={item && item.title_services} className="w-full lg:w-1/3 px-4 sm:px-0 lg:mx-4 mb-10 lg:my-0 flex-grow-0 flex-shrink-0 lg:flex-shrink lg:flex-grow">
                  <div className="shadow-xl hover:shadow-lg rounded-lg p-8 md:p-10 xl:p-12 text-center items-center flex flex-col h-full group hover:bg-lightorange transform hover:translate-y-1 transition duration-500 ease-in-out">
                    <div className="w-20 h-20 border-2 border-black p-5 rounded-full transition duration-300 ease-in-out group-hover:hidden group-hover:border-white">
                      <img src={item && item.icon_services.url} alt="development" />
                    </div>
                    <div className="transform transition duration-600 ease-in-out">
                      <div className="relative w-auto h-10 z-10 my-2">
                        <Title className="mx-auto table relative underlined" level="3">
                          {item && item.title_services}
                        </Title>
                      </div>
                      <Content className="truncate-6-lines transition duration-500 ease-in-out">{item.text_services}</Content>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
